module.exports = __webpack_public_path__ + "static/media/xl-cta-pattern-right.5dbe8beb.svg";